import { render, staticRenderFns } from "./OtherOutStock.vue?vue&type=template&id=9afc152c&scoped=true&"
import script from "./OtherOutStock.vue?vue&type=script&lang=js&"
export * from "./OtherOutStock.vue?vue&type=script&lang=js&"
import style0 from "./OtherOutStock.vue?vue&type=style&index=0&id=9afc152c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afc152c",
  null
  
)

export default component.exports